import { gql } from '@apollo/client';

export const AVATAR_FRAGMENT = gql`
  fragment Avatar on PictureType {
    original
    thumbnail
    color
  }
`;
